import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import OktaError from '../components/OktaError';
import PrivateRoutes from '../utils/PrivateRoutes';
import LandingPage from '../pages/LandingPage/LandingPage';
import CheckItems from '../pages/PortfolioMasterData/CheckItems';
import { useOkta } from '../hooks/oktaHook';
import AppPages from '../components/Layout/AppPages';
import PageNotFound from '../components/PageNotFound/PageNotFound';
import { CORE_USER, GENERAL_USER, TPO_ADMIN } from '../utils/Constants';

const Routers = () => {
  const { authState } = useOkta();
  function filterPagesWithNesting(data, targetPath) {
    return data.reduce((result, page) => {
      const filteredPage = { ...page };

      if (page.pageName === 'Readiness') {
        // Filter out the "Review Items" tab from subPages
        filteredPage.subPages = page.subPages?.filter((subPage) => subPage.path !== targetPath);
        result.push(filteredPage);
      } else if (page.subPages) {
        // Recursively filter subPages
        const filteredSubPages = filterPagesWithNesting(page.subPages, targetPath);
        if (filteredSubPages.length > 0) {
          filteredPage.subPages = filteredSubPages;
          result.push(filteredPage);
        }
      } else {
        result.push(filteredPage);
      }

      return result;
    }, []);
  }

  const duplicateAppPages = filterPagesWithNesting(AppPages, '/portfolio/check-items');

  return (
    <Routes>
      {!authState?.isAuthenticated ? (
        <Route key="landing-component" path="/" exact element={<LandingPage />} />
      ) : (
        <Route key="redirect-component" path="/" element={<Navigate to="/home" replace />} />
      )}

      {/* Logout via okta */}
      <Route key="landing-component" path="/logout" exact element={<LandingPage />} />
      <Route
        key="landing-component"
        path="/info"
        exact
        element={<LandingPage loginBtnDisabled={true} />}
      />

      {/* Okta LoginCallback route */}
      <Route
        path="/login"
        element={
          <LoginCallback
            errorComponent={(props) => <OktaError error={props?.error ?? undefined} />}
            loadingElement={<div>Loading...</div>}
          />
        }
      />

      {/* Protected by OKta accesstoken */}
      {duplicateAppPages.map((page) => {
        // Check if the page has subPages
        if (page.subPages) {
          // returning subpage routes, skipping route for "/portfolio/check-items"
          return page?.subPages?.map((subPage) => (
            <Route
              key={subPage.pageName}
              path={subPage.path}
              element={
                <PrivateRoutes accessScope={subPage.allowedUserScope}>
                  {subPage.pageComponent}
                </PrivateRoutes>
              }
            />
          ));
        } else {
          // If no subPages, create a single route for the page
          return (
            <Route
              key={page.pageName}
              path={page.path}
              element={
                <PrivateRoutes accessScope={page.allowedUserScope}>
                  {page.pageComponent}
                </PrivateRoutes>
              }
            />
          );
        }
      })}

      {/* Manual routes which are not visible on Navbar */}
      <Route
        key="portfolio-check-component"
        path="/portfolio/check-items"
        exact
        element={
          <PrivateRoutes accessScope={[CORE_USER, GENERAL_USER, TPO_ADMIN]}>
            <CheckItems />
          </PrivateRoutes>
        }
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default Routers;
